import { LoadingButton, LoadingButtonProps } from '@components/Buttons/loading';
import { color, prop } from '@lib/style/theme';
import { unitStrict } from '@lib/style/unit';
import { namedComponent } from '@packages/react/lib/named';
import { ColorType } from '@packages/style/colors';
import React from 'react';
import styled from 'styled-components';

export interface OutlinedButtonProps extends Omit<LoadingButtonProps, 'color'> {
    color?: ColorType;
    borderSize?: number;
}

export const OutlinedButton = styled(
    namedComponent(
        ({ borderSize, color, children, ...props }: OutlinedButtonProps) => (
            <LoadingButton variant={'contained'} {...props}>
                {children}
            </LoadingButton>
        ),
        'OutlinedButton',
    ),
)<OutlinedButtonProps>`
    && {
        border-color: ${color('color')};
        border-width: ${prop('borderSize', 1, unitStrict)};
        box-shadow: none;
        color: ${color('color', 'primary')};
    }
`;

OutlinedButton.defaultProps = { color: 'primary', borderSize: 1 };
